import { BUSCAR_EMISSAO_CTE_OS_NOTA_FISCAL } from '../../actions/types'

const initialState = undefined;

const estadoInicial = {
    tipoServico: { valor: '',  chave: '' },
    tipoFretamento: { valor: '',  chave: '' },
    naturezaOperacao: '',
    cidadeOrigem: {
        descricaoUf: '',
        nome: '',
        nomeComUf: '',
        uf: ''
    },
    cidadeDestino: {
        descricaoUf: '',
        nome: '',
        nomeComUf: '',
        uf: ''
    },
    percursosCteOsDto: '',
    tomador: {
      tipoTomador: '',
      inscricaoEstadual: '',
      nomePessoa: '',
      nomeFantasia: '',
      endereco: { cep: '', logradouro: '', bairro: '', complemento: '', nomeCidade: '', uf: '' },
      cnpj:'',
      cpf: '',
      telefone: '',
      email: ''
    },
    quantidadeCarga: '',
    descricaoServico: '',
    valorServico: '',
    responsavelSeguro: { valor: '',  chave: '' },
    seguro: { valor: '',  chave: '' },
    veiculo: {
      placa: '',
      nome: '',
      renavam: ''
    },
    termoAutorizacaoFretamento: '',
    empresa: {
      nome: '',
      cnpj: '',
      nomeFantasia: '',
      inscricaoEstadual: '',
      enderecoEmpresaDto: []
    },
    ultimoHistoricoEmissaoCteOs: {
      dataHora: null,
      motivo: '',
      situacaotransmissao: {
          chave: '',
          valor: ''
      },
      chaveCte: null
    }

}

export default function reducerBuscarEmissaoCteOsNotaFiscal (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_EMISSAO_CTE_OS_NOTA_FISCAL: {
      const emissaoCteOs = action.payload.data;

      if (emissaoCteOs) {
        return emissaoCteOs
      }
      return estadoInicial
    }

    default: {
      return state
    }
  }
}
